import { render, staticRenderFns } from "./PlusLegacy.vue?vue&type=template&id=01ac6b15&scoped=true"
import script from "./PlusLegacy.vue?vue&type=script&lang=js"
export * from "./PlusLegacy.vue?vue&type=script&lang=js"
import style0 from "./PlusLegacy.vue?vue&type=style&index=0&id=01ac6b15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ac6b15",
  null
  
)

export default component.exports